const BASE_URL = 'https://api.dev.auxo.dk/public/content';

export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/${collectionName}`);
    if (!response.ok) throw new Error(`Failed to fetch ${collectionName}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function fetchBySlug(slug, lang = 'da') {
  try {
    const url = lang 
      ? `https://api.dev.auxo.dk/public/by-slug/${lang}/${slug}`
      : `https://api.dev.auxo.dk/public/by-slug/${slug}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch slug: ${slug}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}
